import PropTypes from 'prop-types';
import React from 'react';

import { Button } from '../../button/new';
import { Flex } from '../../grid';
import { Modal } from '../../modal/new';
import { P } from '../../typography/new';

const VARIANTS = {
  OVER_CAP: 'over-cap',
  PAST_CUTOFF: 'past-cutoff',
};

const formatDollars = value => {
  if (value == null) return '';
  return Number.isInteger(value) ? `$${value}` : `$${value.toFixed(2)}`;
};

const ShortLeadTimeErrorModal = ({
  open,
  variant,
  maxValue,
  standardLeadHours,
  cutoffTime,
  requestedTime,
  onClose,
}) => {
  let body = '';
  if (variant === VARIANTS.OVER_CAP) {
    body = `Orders over ${formatDollars(
      maxValue
    )} require ${standardLeadHours} hours’ lead time. Please select another pickup date and time.`;
  } else if (variant === VARIANTS.PAST_CUTOFF) {
    body = `Orders placed after ${cutoffTime} cannot be completed by ${requestedTime}. Please select another pickup date and time.`;
  }

  return (
    <Modal
      open={open}
      handleClose={onClose}
      modalTitle=""
      hideBottomDecal={false}
      buttons={{
        primary: (
          <Button onClick={onClose} size="tall" isFullWidth widthType="fullWidth">
            OK
          </Button>
        ),
      }}
    >
      <Flex flexDirection="column" gap="12px" py={{ xs: '8px', md: '16px' }} textAlign="center">
        <P variant="large-bold" as="h2">
          Sorry, we won’t be able to fulfil this order
        </P>
        <P variant="standard">{body}</P>
      </Flex>
    </Modal>
  );
};

ShortLeadTimeErrorModal.propTypes = {
  open: PropTypes.bool.isRequired,
  variant: PropTypes.oneOf([VARIANTS.OVER_CAP, VARIANTS.PAST_CUTOFF]).isRequired,
  maxValue: PropTypes.number,
  standardLeadHours: PropTypes.number,
  cutoffTime: PropTypes.string,
  requestedTime: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

ShortLeadTimeErrorModal.defaultProps = {
  maxValue: null,
  standardLeadHours: null,
  cutoffTime: null,
  requestedTime: null,
};

ShortLeadTimeErrorModal.VARIANTS = VARIANTS;

export { ShortLeadTimeErrorModal };
